export default "__VITE_ASSET__RGHS4T57__"